import React, { useState } from "react";
import SignatureField from "../common/SignatureField"; // adjust path if needed


export default function StaffRegistrationFormShort({ onSubmit, initialData }) {
  const [formData, setFormData] = useState(
    initialData || {
      fullName: "",
      dob: "",
      addressLine1: "",
      postcode: "",
      phone: "",
      email: "",
      niNumber: "",
      roleAppliedFor: "",
      experienceSummary: "",
      keySkills: "",
      daysAvailable: "",
      hoursAvailable: "",
      rightToWork: "",
      otherEmployment: "",
      otherEmploymentDetails: "",
      declarationAccepted: false,
      declarationName: "",
      declarationDate: "",
    }
  );

  const [errors, setErrors] = useState({});

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.fullName.trim()) newErrors.fullName = "Required";
    if (!formData.dob) newErrors.dob = "Required";
    if (!formData.addressLine1.trim()) newErrors.addressLine1 = "Required";
    if (!formData.postcode.trim()) newErrors.postcode = "Required";
    if (!formData.phone.trim()) newErrors.phone = "Required";
    if (!formData.email.trim()) newErrors.email = "Required";
    if (!formData.roleAppliedFor.trim()) newErrors.roleAppliedFor = "Required";
    if (!formData.rightToWork)
      newErrors.rightToWork = "Please confirm your right to work";
    if (!formData.declarationAccepted)
      newErrors.declarationAccepted = "You must confirm the declaration";
    if (!formData.declarationName.trim())
      newErrors.declarationName = "Please type your full name";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    if (typeof onSubmit === "function") {
      onSubmit(formData);
    } else {
      console.log("Staff Registration (SHORT) data:", formData);
      alert("Form submitted (check console). Wire onSubmit to save to Firestore.");
    }
  };

  const sectionTitle = {
    fontWeight: 600,
    marginTop: 16,
    marginBottom: 8,
    fontSize: 14,
    color: "#111827",
  };

  const labelStyle = {
    fontSize: 13,
    color: "#374151",
    marginBottom: 4,
    display: "block",
  };

  const inputStyle = {
    width: "100%",
    padding: "8px 10px",
    borderRadius: 8,
    border: "1px solid #d1d5db",
    fontSize: 13,
    outline: "none",
  };

  const textAreaStyle = {
    ...inputStyle,
    minHeight: 70,
    resize: "vertical",
  };

  const errorStyle = {
    fontSize: 12,
    color: "#b91c1c",
    marginTop: 2,
  };

  const radioRow = {
    display: "flex",
    alignItems: "center",
    gap: 6,
    fontSize: 13,
    marginRight: 16,
  };

  return (
    <form onSubmit={handleSubmit}>
      <h3 style={{ fontSize: 18, fontWeight: 600, marginBottom: 4 }}>
        Staffing Registration Form (Short)
      </h3>
      <p style={{ fontSize: 12, color: "#6b7280", marginBottom: 16 }}>
        This shorter form captures the key details we need to register you for
        work.
      </p>

      <div style={sectionTitle}>1. Personal Details</div>

      <div style={{ marginBottom: 10 }}>
        <label style={labelStyle}>Full Name *</label>
        <input
          style={inputStyle}
          value={formData.fullName}
          onChange={(e) => handleChange("fullName", e.target.value)}
        />
        {errors.fullName && <div style={errorStyle}>{errors.fullName}</div>}
      </div>

      <div style={{ display: "flex", gap: 10 }}>
        <div style={{ flex: 1, marginBottom: 10 }}>
          <label style={labelStyle}>Date of Birth *</label>
          <input
            type="date"
            style={inputStyle}
            value={formData.dob}
            onChange={(e) => handleChange("dob", e.target.value)}
          />
          {errors.dob && <div style={errorStyle}>{errors.dob}</div>}
        </div>
        <div style={{ flex: 1, marginBottom: 10 }}>
          <label style={labelStyle}>National Insurance Number</label>
          <input
            style={inputStyle}
            value={formData.niNumber}
            onChange={(e) => handleChange("niNumber", e.target.value)}
          />
        </div>
      </div>

      <div style={{ marginBottom: 10 }}>
        <label style={labelStyle}>Address Line 1 *</label>
        <input
          style={inputStyle}
          value={formData.addressLine1}
          onChange={(e) => handleChange("addressLine1", e.target.value)}
        />
        {errors.addressLine1 && (
          <div style={errorStyle}>{errors.addressLine1}</div>
        )}
      </div>

      <div style={{ marginBottom: 10 }}>
        <label style={labelStyle}>Postcode *</label>
        <input
          style={inputStyle}
          value={formData.postcode}
          onChange={(e) => handleChange("postcode", e.target.value)}
        />
        {errors.postcode && (
          <div style={errorStyle}>{errors.postcode}</div>
        )}
      </div>

      <div style={{ display: "flex", gap: 10 }}>
        <div style={{ flex: 1, marginBottom: 10 }}>
          <label style={labelStyle}>Phone Number *</label>
          <input
            style={inputStyle}
            value={formData.phone}
            onChange={(e) => handleChange("phone", e.target.value)}
          />
          {errors.phone && <div style={errorStyle}>{errors.phone}</div>}
        </div>
        <div style={{ flex: 1, marginBottom: 10 }}>
          <label style={labelStyle}>Email *</label>
          <input
            style={inputStyle}
            type="email"
            value={formData.email}
            onChange={(e) => handleChange("email", e.target.value)}
          />
          {errors.email && <div style={errorStyle}>{errors.email}</div>}
        </div>
      </div>

      <div style={sectionTitle}>2. Role & Experience</div>

      <div style={{ marginBottom: 10 }}>
        <label style={labelStyle}>Role applied for *</label>
        <input
          style={inputStyle}
          value={formData.roleAppliedFor}
          onChange={(e) =>
            handleChange("roleAppliedFor", e.target.value)
          }
        />
        {errors.roleAppliedFor && (
          <div style={errorStyle}>{errors.roleAppliedFor}</div>
        )}
      </div>

      <div style={{ marginBottom: 10 }}>
        <label style={labelStyle}>Brief summary of your experience</label>
        <textarea
          style={textAreaStyle}
          value={formData.experienceSummary}
          onChange={(e) =>
            handleChange("experienceSummary", e.target.value)
          }
        />
      </div>

      <div style={{ marginBottom: 10 }}>
        <label style={labelStyle}>Key skills / strengths</label>
        <textarea
          style={textAreaStyle}
          value={formData.keySkills}
          onChange={(e) => handleChange("keySkills", e.target.value)}
        />
      </div>

      <div style={sectionTitle}>3. Availability</div>

      <div style={{ marginBottom: 10 }}>
        <label style={labelStyle}>
          Days available (e.g. Mon–Fri, weekends)
        </label>
        <input
          style={inputStyle}
          value={formData.daysAvailable}
          onChange={(e) =>
            handleChange("daysAvailable", e.target.value)
          }
        />
      </div>

      <div style={{ marginBottom: 10 }}>
        <label style={labelStyle}>
          Hours / shifts you are available (e.g. 9–5, nights, flexible)
        </label>
        <input
          style={inputStyle}
          value={formData.hoursAvailable}
          onChange={(e) =>
            handleChange("hoursAvailable", e.target.value)
          }
        />
      </div>

      <div style={sectionTitle}>4. Right to Work & Other Employment</div>

      <div style={{ marginBottom: 8 }}>
        <span style={labelStyle}>Do you have the right to work in the UK? *</span>
        <div style={{ display: "flex" }}>
          <label style={radioRow}>
            <input
              type="radio"
              name="rightToWork"
              value="yes"
              checked={formData.rightToWork === "yes"}
              onChange={(e) =>
                handleChange("rightToWork", e.target.value)
              }
            />
            Yes
          </label>
          <label style={radioRow}>
            <input
              type="radio"
              name="rightToWork"
              value="no"
              checked={formData.rightToWork === "no"}
              onChange={(e) =>
                handleChange("rightToWork", e.target.value)
              }
            />
            No
          </label>
        </div>
        {errors.rightToWork && (
          <div style={errorStyle}>{errors.rightToWork}</div>
        )}
      </div>

      <div style={{ marginBottom: 8 }}>
        <span style={labelStyle}>
          Are you currently employed by another employer or agency?
        </span>
        <div style={{ display: "flex" }}>
          <label style={radioRow}>
            <input
              type="radio"
              name="otherEmployment"
              value="yes"
              checked={formData.otherEmployment === "yes"}
              onChange={(e) =>
                handleChange("otherEmployment", e.target.value)
              }
            />
            Yes
          </label>
          <label style={radioRow}>
            <input
              type="radio"
              name="otherEmployment"
              value="no"
              checked={formData.otherEmployment === "no"}
              onChange={(e) =>
                handleChange("otherEmployment", e.target.value)
              }
            />
            No
          </label>
        </div>
      </div>

      {formData.otherEmployment === "yes" && (
        <div style={{ marginBottom: 10 }}>
          <label style={labelStyle}>Please give details</label>
          <textarea
            style={textAreaStyle}
            value={formData.otherEmploymentDetails}
            onChange={(e) =>
              handleChange("otherEmploymentDetails", e.target.value)
            }
          />
        </div>
      )}
	  
	  <SignatureField
  label="Sign here (using your finger or mouse)"
  value={formData.signature}
  onChange={(val) => handleChange("signature", val)}
/>

	  
	  
	  
	  
	  
	  

      <div style={sectionTitle}>5. Declaration</div>

      <p style={{ fontSize: 12, color: "#4b5563", marginBottom: 8 }}>
        I confirm that the information I have provided is true and complete to
        the best of my knowledge and I understand that giving false information
        may affect any offer of work.
      </p>

      <label style={{ ...radioRow, marginBottom: 4 }}>
        <input
          type="checkbox"
          checked={formData.declarationAccepted}
          onChange={(e) =>
            handleChange("declarationAccepted", e.target.checked)
          }
        />
        <span style={{ fontSize: 12 }}>
          I confirm the above declaration.*
        </span>
      </label>
      {errors.declarationAccepted && (
        <div style={errorStyle}>{errors.declarationAccepted}</div>
      )}

      <div style={{ display: "flex", gap: 10, marginTop: 8 }}>
        <div style={{ flex: 1, marginBottom: 10 }}>
          <label style={labelStyle}>Type your full name as signature *</label>
          <input
            style={inputStyle}
            value={formData.declarationName}
            onChange={(e) =>
              handleChange("declarationName", e.target.value)
            }
          />
          {errors.declarationName && (
            <div style={errorStyle}>{errors.declarationName}</div>
          )}
        </div>
        <div style={{ flex: 1, marginBottom: 10 }}>
          <label style={labelStyle}>Date</label>
          <input
            type="date"
            style={inputStyle}
            value={formData.declarationDate}
            onChange={(e) =>
              handleChange("declarationDate", e.target.value)
            }
          />
        </div>
      </div>

      <button
        type="submit"
        style={{
          marginTop: 16,
          width: "100%",
          padding: "10px 0",
          borderRadius: 9999,
          border: "none",
          fontSize: 14,
          fontWeight: 600,
          backgroundColor: "#0284c7",
          color: "white",
          cursor: "pointer",
        }}
      >
        Submit Short Registration
      </button>
    </form>
  );
}
